import { defineStore } from "pinia";
import { instance } from "..";

export enum ELoader {
  DEFAULT,
  CHAPTERS,
  TRAILS,
  MATERIALS,
  QUIZ,
  MATERIAL,
  PERCENTAGE,
}

export const store = defineStore({
  id: "loader",
  state: () => ({
    load: {} as Record<ELoader | string, boolean>,
  }),
  actions: {
    start(key: ELoader = ELoader.DEFAULT) {
      this.load[key] = true;
    },
    stop(key: ELoader = ELoader.DEFAULT) {
      let debounceTimer: number | null = null;
      debounceTimer = setTimeout(() => (this.load[key] = false), 250);
    },
  },
});

export const useLoaderStore = store(instance);
